import { OperatingTypes } from '~/app/data/statuses/operatingData';
import { syncTypes } from '~/sqlite/syncDataTypes';

import { syncQueue } from './SyncQueue';

export type QueuedOperatingData = {
    machineId: string | number
    type: number | string
    operatingTime?: string | number
    userId?: number | string
    updatedAt?: string
};

export async function listQueuedOperatingData(userId: number): Promise<QueuedOperatingData[]> {
    const rows = await syncQueue.listByUserId(userId);
    const queued: QueuedOperatingData[] = [];
    for (const row of rows) {
        if (row.typeOfData !== syncTypes.UPDATE_OPERATING_DATA) {
            continue;
        }
        try {
            queued.push(JSON.parse(row.data) as QueuedOperatingData);
        } catch {
            // Malformed rows are dropped by SyncManager; ignore them here.
        }
    }
    return queued;
}

export function isOperatingDataAwaitingSync(
    queued: boolean,
    loaded: boolean,
    pendingSync?: boolean,
): boolean {
    if (loaded) {
        return queued;
    }
    return queued || !!pendingSync;
}

export async function hasPendingOperatingDataSync(
    userId: number,
    machineId: string | number,
    operatingType: number,
): Promise<boolean> {
    const queued = await listQueuedOperatingData(userId);
    return queued.some(row =>
        String(row.machineId) === String(machineId)
        && Number(row.type) === Number(operatingType)
    );
}

export const isOperatingCountType = (type: number | string | undefined): boolean =>
    Number(type) === OperatingTypes.OPERATING_COUNT;
